import { render, staticRenderFns } from "./NotificationSettings.vue?vue&type=template&id=514382f0&scoped=true"
import script from "./NotificationSettings.vue?vue&type=script&lang=js"
export * from "./NotificationSettings.vue?vue&type=script&lang=js"
import style0 from "./NotificationSettings.vue?vue&type=style&index=0&id=514382f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514382f0",
  null
  
)

export default component.exports